<template>
  <div
    class="trainer-ranges-hand-strength trarangeshand"
    :class="{ trarangeshand_skeleton: skeleton }"
  >
    <!-- <CardRow :cards="hand" class="mr-auto" size="mini" /> -->
    <!-- <CardRow :cards="hand" v-if="hasCards" /> -->
    <!-- <CardRow :cards="hand" size="small" v-if="hasCards" /> -->
    <!-- style="max-width: 3rem" -->
    <!-- <slot name="title">
      <div class="d-flex text_tab_small">
        {{ $t(`trainer.trainer_hand_strength_title`) }}
        <slot name="title_after"></slot>
      </div>
    </slot> -->

    <div class="trarangeshand_content">
      <div
        class="trarangeshand_chart"
        :class="{ trarangeshand_chart_skeleton: isNA }"
      >
        <div class="trarangeshand_chart_legend">
          <div class="">
            {{ $t('common.hand_strength_short') }}
          </div>
          <div class="trarangeshand_chart_legend_value">
            {{ isNA ? 'N/A' : numFixedUnit(xEqLeft * 100, 'eq') }}%
          </div>
        </div>
        <div class="trarangeshand_chart_column clr-primary">
          <div
            class="trarangeshand_chart_rest"
            :style="`width:${(1 - xEqLeft) * 100}%`"
          ></div>
        </div>
      </div>
      <div
        class="trarangeshand_chart"
        :class="{ trarangeshand_chart_skeleton: skeleton || isNA }"
      >
        <div class="trarangeshand_chart_legend">
          <div class="">
            {{ $t('tabs.eq') }}
          </div>
          <div class="trarangeshand_chart_legend_value">
            {{ isNA ? 'N/A' : numFixedUnit(eq * 100, 'eq') }}%
          </div>
        </div>
        <div class="trarangeshand_chart_column clr-primary">
          <div
            class="trarangeshand_chart_rest"
            :style="`width:${(1 - eq) * 100}%`"
          ></div>
        </div>
        <div
          v-if="categoryHand && categoryDraw"
          class="trarangeshand_categories"
        >
          <div class="trarangeshand_categories_category">
            {{ $t(`browse.filter_rules.${categoryHand}`) }}
          </div>
          <div class="circle-bullet clr-grey my-auto"></div>

          <div class="trarangeshand_categories_category">
            {{ $t(`browse.filter_rules.${categoryDraw}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { getCategoriesHandIndex } from '@/helpers/constants'
// import CardRow from '@/components/CardRow/CardRow'

export default {
  name: 'TrainerHandStrength',
  mixins: [format_mix],
  props: {
    handInfo: Object,
    skeleton: Boolean,
    isNA: Boolean,
    hasCards: Boolean,
  },
  computed: {
    xEqLeft() {
      return this.handInfo?.eq_percentile || 0
    },
    eq() {
      return this.handInfo?.eq || ''
    },
    hand() {
      return this.handInfo?.hand || ''
    },
    categoryHand() {
      return getCategoriesHandIndex()[this.handInfo?.hand_category]
    },
    categoryDraw() {
      return getCategoriesHandIndex()[this.handInfo?.draw_category]
    },
  },
  // components: {
  // CardRow,
  // },
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.trarangeshand {
  width: 100%;
  --chart-height: var(--height-chart-small);
  --size-legend: 0.875rem;
  --weight: 700;
  --weight-legend: 700;
  --radius: 4px;

  font-size: var(--size-legend);
  font-weight: var(--weight-legend);
  &_content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &_skeleton {
    .trarangeshand_chart_legend_value {
      opacity: 0;
    }
    .trarangeshand_chart_column {
      background: var(--clr-black-3);
      width: 100% !important;
      .trarangeshand_chart_rest {
        display: none;
      }
    }
  }
  &_chart {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    // border-radius: 99px;
    border-radius: var(--radius);
    // --size-legend: 1rem;
    &_skeleton {
      .trarangeshand_chart_column {
        background: var(--clr-black-3) !important;
      }
      .trarangeshand_chart_rest {
        display: none;
      }
      .trarangeshand_chart_legend_value {
        color: var(--clr-grey-2);
      }
    }
    &_column {
      height: var(--chart-height);
      width: 100%;
      min-width: 2px;
      border-radius: var(--radius);
      background: currentColor;
      background: linear-gradient(
        90deg,
        var(--clr-eveqeqrbl0),
        var(--clr-eveqeqrbl50),
        var(--clr-eveqeqrbl100)
      );
      position: relative;
      display: flex;
      justify-content: center;
      min-height: 2px;
      // transition: 0.2s;
    }
    &_legend {
      display: flex;
      justify-content: center;
      position: relative;
      align-items: center;
      // font-size: var(--size-legend);
      // font-weight: var(--weight-legend);
      color: var(--clr-grey-2);
      &_value {
        margin-left: auto;
        color: var(--clr-white-0);
        // font-size: 1rem;
        // font-weight: 700;
      }
    }
    &_rest {
      position: absolute;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
      height: 100%;
      // border-top-right-radius: var(--radius) ;
      // border-bottom-right-radius: 99px;
    }
  }
  &_categories {
    // margin: 0 0.5rem;
    // margin: 0.25rem 0 0 0;
    flex: 1;
    display: flex;
    // flex-direction: column;
    // align-items: center;
    grid-gap: 0.5rem;
    // margin: 0.5rem 0 0 0;

    &_category {
      // font-size: var(--size-legend);
      // font-weight: var(--weight-legend);
      color: var(--clr-grey-2);
      // text-transform: uppercase;
      // line-height: 1;
    }
  }
}
</style>
